<template>
  <div>
    <v-card class="mb-5">
      <v-card-title class="card-title">Datos del puesto</v-card-title>
      <v-card-text>
        <v-row class="pa-3">
          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Nombre del puesto*</v-label></div>
            <v-text-field name="name" data-vv-as="nombre del puesto" v-model="item.name" v-validate="'required|max:150'" :disabled="disabled" outlined dense></v-text-field>
            <span class="red--text">{{ errors.first("name") }}</span>
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Tipo de nodo*</v-label></div>
            <v-select name="node_type" data-vv-as="tipo de nodo" v-model="item.node_type" v-validate="'required'" :items="node_types" item-text="name" item-value="id" return-object :disabled="disabled" outlined dense></v-select>
            <span class="red--text">{{ errors.first("node_type") }}</span>
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Referencia externa</v-label></div>
            <v-text-field name="external_reference" data-vv-as="referencia externa" v-model="item.external_reference" v-validate="'max:255'" :disabled="disabled" outlined dense></v-text-field>
            <span class="red--text">{{ errors.first("external_reference") }}</span>
          </v-col>

          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Sucursal*</v-label></div>
            <v-select name="sucursal" data-vv-as="sucursal" v-model="item.sucursal" v-validate="'required'" :items="sucursales" item-text="name" item-value="id" return-object :disabled="disabled" outlined dense></v-select>
            <span class="red--text">{{ errors.first("sucursal") }}</span>
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Sector</v-label></div>
            <v-select v-model="item.worksector" :items="worksectors" item-text="name" item-value="id" return-object clearable :disabled="disabled" outlined dense></v-select>
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Estado</v-label></div>
            <v-select v-model="item.enabled" :items="status_options" :disabled="disabled" outlined dense></v-select>
          </v-col>

          <v-col cols="12" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Descripción / funciones</v-label></div>
            <v-textarea v-model="item.description" rows="3" auto-grow :disabled="disabled" outlined dense></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-5">
      <v-card-title class="card-title">Posición en el organigrama</v-card-title>
      <v-card-text>
        <v-row class="pa-3">
          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Depende de{{ parent_required ? "*" : "" }}</v-label></div>
            <v-autocomplete name="parent" data-vv-as="depende de" v-model="item.parent" v-validate="parent_required ? 'required' : ''" :items="parent_options" item-text="name" item-value="id" return-object clearable :disabled="disabled" outlined dense></v-autocomplete>
            <span class="red--text">{{ errors.first("parent") }}</span>
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Orden entre pares</v-label></div>
            <v-text-field name="sort_order" data-vv-as="orden" type="number" min="0" v-model="item.sort_order" v-validate="'integer|min_value:0'" :disabled="disabled" outlined dense></v-text-field>
            <span class="red--text">{{ errors.first("sort_order") }}</span>
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Dependientes al abrir</v-label></div>
            <v-select v-model="item.children_collapsed" :items="collapsed_options" :disabled="disabled" outlined dense></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-5">
      <v-card-title class="card-title">Responsable</v-card-title>
      <v-card-text>
        <v-row class="pa-3" align="center">
          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Legajo responsable</v-label></div>
            <v-autocomplete v-model="item.legajo" :items="legajo_options" :item-text="legajoText" item-value="id" return-object clearable placeholder="Sin asignar" :loading="loading_legajos" :disabled="disabled" outlined dense></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <div class="d-flex align-items-center mb-2"><font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" /><v-label class="label-input">Suplente</v-label></div>
            <v-autocomplete name="substitute" v-model="item.substitute" :items="substitute_options" :item-text="legajoText" item-value="id" return-object clearable placeholder="Sin suplente" :loading="loading_legajos" :disabled="disabled" outlined dense></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <v-checkbox v-model="is_vacant" label="Puesto vacante (sin responsable)" :disabled="disabled" hide-details class="mt-3"></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "NodeForm",
  props: {
    item: Object,
    // Listado plano de puestos de la empresa
    nodes: { type: Array, default: () => [] },
    node_types: { type: Array, default: () => [] },
    sucursales: { type: Array, default: () => [] },
    worksectors: { type: Array, default: () => [] },
    legajos: { type: Array, default: () => [] },
    loading_legajos: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      status_options: [
        { value: true, text: "Activo" },
        { value: false, text: "Inactivo" },
      ],
      collapsed_options: [
        { value: false, text: "Expandidos" },
        { value: true, text: "Contraídos" },
      ],
    };
  },
  computed: {
    // Excluye al propio puesto y sus dependientes para no generar ciclos
    parent_options() {
      if (!(this.item.id > 0)) return this.nodes;

      const excluded = [this.item.id];
      let added = true;
      while (added) {
        added = false;
        this.nodes.forEach((node) => {
          if (node.parent_id != null && excluded.includes(node.parent_id) && !excluded.includes(node.id)) {
            excluded.push(node.id);
            added = true;
          }
        });
      }
      return this.nodes.filter((node) => !excluded.includes(node.id));
    },
    // Solo puede quedar sin superior si no existe otra raiz
    parent_required() {
      return this.nodes.some((node) => node.parent_id == null && node.id != this.item.id);
    },
    // Se agregan los legajos asignados aunque ya no esten activos, para poder mostrarlos
    legajo_options() {
      const options = [...this.legajos];
      [this.item.legajo, this.item.substitute].forEach((legajo) => {
        if (legajo != null && !options.some((l) => l.id == legajo.id)) options.push(legajo);
      });
      return options;
    },
    substitute_options() {
      return this.legajo_options.filter((l) => this.item.legajo == null || l.id != this.item.legajo.id);
    },
    is_vacant: {
      get() {
        return this.item.legajo == null;
      },
      set(value) {
        if (value) this.item.legajo = null;
      },
    },
  },
  methods: {
    legajoText(legajo) {
      return legajo.name + " " + legajo.surname;
    },
    async validate() {
      return this.$validator.validateAll();
    },
  },
};
</script>
